import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react'
import { Button } from 'react-bootstrap';

import Table from '../../../../../facturotopia/table/Table';


class NominaPercepcionHorasExtraList extends Component {

  handleEdit = (item) => {
    this.handleOnDelete(item);
    this.props.onEdit(item);
  }

  handleOnDelete = (item) => {
    const newData = this.props.data.filter((value) => {
      return value.id !== item.id;
    });

    this.props.onChange(newData);
  }

  render() {
    const { data } = this.props;

    return (
      <>
        <Table
          columns={ columns(this.handleEdit, this.handleOnDelete) }
          rowKey={ 'TipoHoras' }
          data={ data }
        >
        </Table>
      </>
    )
  }
}

const columns = (handleEdit, handleOnDelete) => [
  {
    align: 'center',
    key: '__',
    title: '',
    dataIndex: '__',
    render: (item) => {
      return (
        <>
          <Button
            variant="secondary"
            size="sm"
            onClick={ handleEdit.bind(null, item)}
          >
            <FontAwesomeIcon icon={ ['far', 'edit'] } />
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={ handleOnDelete.bind(null, item)}
          >
            <FontAwesomeIcon icon={ ['fas', 'trash'] } />
          </Button>
        </>
      );
    }
  },
  {
    align: 'right',
    key: 'Dias',
    title: 'Dias',
    dataIndex: 'Dias',
  },
  {
    key: 'TipoHoras',
    title: 'TipoHoras',
    dataIndex: 'TipoHoras',
  },
  {
    align: 'right',
    key: 'HorasExtra',
    title: 'HorasExtra',
    dataIndex: 'HorasExtra',
  },
  {
    align: 'right',
    key: 'ImportePagado',
    title: 'Importe Pagado',
    dataIndex: 'ImportePagado',
  },
];

export default NominaPercepcionHorasExtraList;